let ctx = null;
let master = null;
let ambienceOn = false;

export const ensureAudio = () => {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);

    const len = ctx.sampleRate * 4;
    const buffer = ctx.createBuffer(1, len, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    let last = 0;
    for (let i = 0; i < len; i++) {
      const white = Math.random() * 2 - 1;
      last = (last + 0.02 * white) / 1.02;
      data[i] = last * 3.2;
    }
    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    noise.loop = true;
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 300;
    const noiseGain = ctx.createGain();
    noiseGain.gain.value = 0.4;
    noise.connect(lp);
    lp.connect(noiseGain);
    noiseGain.connect(master);

    const droneGain = ctx.createGain();
    droneGain.gain.value = 0.07;
    [55, 110.4, 164.8].forEach((f) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = f;
      osc.connect(droneGain);
      osc.start();
    });
    droneGain.connect(master);

    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.07;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.08;
    lfo.connect(lfoGain);
    lfoGain.connect(master.gain);
    lfo.start();
    noise.start();
  }
  return { ctx, master };
};

export const unlockAudio = () => {
  const { ctx: c } = ensureAudio();
  if (c.state === "suspended") c.resume();
};

export const setAmbience = async (on) => {
  const { ctx: c, master: m } = ensureAudio();
  ambienceOn = on;
  const now = c.currentTime;
  m.gain.cancelScheduledValues(now);
  if (on) {
    await c.resume();
    m.gain.setTargetAtTime(0.5, now, 1.2);
  } else {
    m.gain.setTargetAtTime(0.0001, now, 0.5);
  }
};

export const playSpeech = async (url) => {
  const { ctx: c, master: m } = ensureAudio();
  if (c.state === "suspended") await c.resume();
  const res = await fetch(url);
  if (!res.ok) return;
  const buf = await c.decodeAudioData(await res.arrayBuffer());
  const src = c.createBufferSource();
  src.buffer = buf;
  const speechGain = c.createGain();
  speechGain.gain.value = 1;
  src.connect(speechGain);
  speechGain.connect(c.destination);
  const now = c.currentTime;
  if (ambienceOn) m.gain.setTargetAtTime(0.12, now, 0.4);
  src.onended = () => {
    if (ambienceOn) m.gain.setTargetAtTime(0.5, c.currentTime, 0.8);
  };
  src.start();
};
